import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AclDataModule } from '../acl-data/acl-data.module';
import { FolderViewsModule } from '../folder-views/folder-views.module';
import { DemoContentComponent } from './components/demo-content/demo-content.component';
import { ACLInfoService } from './services/acl-info.service';
import { ACLRouteDataService } from './services/acl-route-data.service';
import { NavigationModule } from '../navigation/navigation.module';
import { ReportsModule } from '../reports/reports.module';
import { BrowseResolverService } from './services/browse-resolver.service';
import { DocumentchoicesResolverService } from './services/document-choices.service';

@NgModule({
    declarations: [DemoContentComponent],
    exports: [DemoContentComponent],
    imports: [
        CommonModule,
        HttpClientModule,
        AclDataModule,
        FolderViewsModule,
        RouterModule.forChild([]),
        NavigationModule,
        ReportsModule,
    ],
    providers: [
        ACLInfoService,
        ACLRouteDataService,
        BrowseResolverService,
        DocumentchoicesResolverService,
    ],
})
export class ACLNavModule {}
